module.exports = __webpack_public_path__ + "img/icon3.ff0eda5a.png";